<template>
  <v-container class="pa-0 ma-0">
    <v-row class="mt-5">
      <v-col class="text-center">
        <h1>{{ $t('content.jobFind.label') }}</h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-tabs
          color="grey lighten-5"
          slider-color="primary"
          active-class="primary"
          grow
          :vertical="$vuetify.breakpoint.smAndDown"
          :hide-slider="$vuetify.breakpoint.smAndDown"
          :centered="$vuetify.breakpoint.mdAndUp"
        >
          <v-tab @click="$vuetify.goTo('#section-1')">
            {{ $t('content.howItWorksEmployee.label') }}
          </v-tab>
          <v-tab @click="$vuetify.goTo('#section-2')">
            {{ $t('content.advantagesEmployee.label') }}
          </v-tab>
          <v-tab @click="$vuetify.goTo('#section-3')">
            {{ $t('content.employeesSays.label') }}
          </v-tab>
          <v-tab @click="$vuetify.goTo('#section-4')">
            {{ $t('content.faqsEmployees.label') }}
          </v-tab>
        </v-tabs>
        <v-divider/>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-container class="mx-0 my-5 pa-0" grid-list-xl>
          <v-row>
            <v-col class="text-center">
              <div class="responsive-video-container">
                <iframe
                  class="responsive-video"
                  :src="`https://www.youtube.com/embed/${youtubeVideoId}?rel=0&showinfo=0`"
                  frameborder="0"
                  allow="autoplay; encrypted-media"
                  allowfullscreen>
                </iframe>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
    <v-row>
      <v-col>

        <v-container class="mx-0 my-5 pa-0" grid-list-xl id="section-1">
          <v-row>
            <v-col class="text-center">
              <h2>{{ $t('content.howItWorksEmployee.label') }}</h2>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col
              :cols="12" :sm="8"
              class="text-center"
              v-html="$t('content.howItWorksEmployee.text1')"
            />
          </v-row>
          <v-row justify="center">
            <v-col
              :cols="12" :sm="8"
              class="text-center"
              v-html="$t('content.howItWorksEmployee.text2')"
            />
          </v-row>
        </v-container>

        <v-divider class="my-5 py-5"/>

        <v-container class="mx-0 my-5 pa-0" grid-list-xl id="section-2">
          <v-row>
            <v-col class="text-center">
              <h2>{{ $t('content.advantagesEmployee.label') }}</h2>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col
              :cols="12" :sm="8"
              class="text-center"
            >
              <i18n path="content.advantagesEmployee.text1">
                <router-link
                  :to="{ name: 'page.employee.further-education', params: { lang: language } }"
                >
                  {{ $t('content.advantagesEmployee.text1link1') }}
                </router-link>
                <router-link
                  :to="{ name: 'page.employee.seco-pilot', params: { lang: language } }"
                >
                  {{ $t('content.advantagesEmployee.text1link2') }}
                </router-link>
              </i18n>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col
              :cols="12" :sm="8"
              class="text-center"
            >
              <i18n path="content.advantagesEmployee.text1Additional">
                <router-link
                  :to="{ name: 'page.employee.seco-pilot', params: { lang: language } }"
                >
                  {{ $t('content.advantagesEmployee.text1Additionallink') }}
                </router-link>
              </i18n>
            </v-col>
          </v-row>
        </v-container>

        <v-divider class="my-5 py-5"/>

        <v-container class="mx-0 my-5 pa-0" grid-list-xl id="section-3">
          <v-row>
            <v-col class="text-center">
              <h2>{{ $t('content.employeesSays.label') }}</h2>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col :cols="12" :sm="8" class="d-flex justify-center">
              <v-carousel
                :value="startQuote"
                interval="20000"
                :show-arrows="true"
                hide-delimiters
              >
                <v-carousel-item
                  v-for="(item, index) in quotes"
                  :key="index"
                  color="transparent"
                >
                  <v-sheet
                    height="100%"
                    tile
                    light
                    color="transparent"
                  >
                    <v-row
                      class="fill-height"
                      align="center"
                      justify="center"
                    >
                      <v-col :cols="10" class="text-center">
                        <v-avatar size="200" class="mb-5">
                          <v-img :src="`${imagePath}${item.img}`"/>
                        </v-avatar>
                        <div>
                          <strong v-html="item.person"></strong><br>
                          <div v-html="item.text"></div>
                        </div>
                      </v-col>
                    </v-row>
                  </v-sheet>
                </v-carousel-item>
              </v-carousel>
            </v-col>
          </v-row>
        </v-container>

        <v-divider class="my-5 py-5"/>

        <v-container class="mx-0 my-5 pa-0" grid-list-xl id="section-4">
          <v-row>
            <v-col class="text-center">
              <h2>{{ $t('content.faqsEmployees.label') }}</h2>
            </v-col>
          </v-row>
          <v-row v-for="(section, index) in faqs" :key="index" justify="center">
            <v-col :cols="12" :sm="8">
              <v-card flat color="transparent">
                <v-card-title class="justify-center text-center">
                  <h3>{{ section.label }}</h3>
                </v-card-title>
                <v-card-text class="pa-0 mx-0">
                  <v-expansion-panels accordion flat>
                    <v-expansion-panel
                      v-for="(item, index) in section.items"
                      :key="index"
                      class="elevation-0"
                      flat
                    >
                      <v-expansion-panel-header>
                        {{ item.question }}
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <div v-if="item.link">
                          <i18n :path="item.answer" v-if="item.type === 'link'">
                            <template #linebreak>
                              <br>
                            </template>
                            <template #action>
                              <router-link :to="{ name: item.routeName, params: { lang: language } }">
                                {{ $t(`${item.answer}link`) }}
                              </router-link>
                            </template>
                          </i18n>
                          <i18n :path="item.answer" v-if="item.type === 'contact'">
                            <template #linebreak>
                              <br>
                            </template>
                            <a @click="openContactFormDialog()">
                              {{ $t(`${item.answer}link`) }}
                            </a>
                          </i18n>
                        </div>
                        <div v-else v-html="item.answer"/>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapState: mapUserState } = createNamespacedHelpers('user');

export default {
  name: 'JobFind',
  data() {
    return {
      startQuote: 1,
      imagePath: '/static/quotes/employees/',
    };
  },
  mounted() {
    this.generateStartQuote();
    this.$nextTick(() => {
      this.scrollToSection(this.$route.hash);
    });
  },
  computed: {
    ...mapUserState([
      'authUser',
      'language',
    ]),
    youtubeVideoId() {
      if (this.$i18n.locale === 'it') {
        return 'TD1GA2NVZmw';
      }
      return 'gdfD-uMH0xE';
    },
    quotes() {
      const quotes = [
        {
          person: this.$i18n.t('content.employeesSays.1.person'),
          text: this.$i18n.t('content.employeesSays.1.text'),
          img: 'marika-somaini.jpg',
        },
        {
          person: this.$i18n.t('content.employeesSays.2.person'),
          text: this.$i18n.t('content.employeesSays.2.text'),
          img: 'alessia-tagli.jpg',
        },
        {
          person: this.$i18n.t('content.employeesSays.3.person'),
          text: this.$i18n.t('content.employeesSays.3.text'),
          img: 'fabio-dellava.jpg',
        },
        {
          person: this.$i18n.t('content.employeesSays.4.person'),
          text: this.$i18n.t('content.employeesSays.4.text'),
          img: 'corrado-taglioni.jpg',
        },
        {
          person: this.$i18n.t('content.employeesSays.5.person'),
          text: this.$i18n.t('content.employeesSays.5.text'),
          img: 'nina-della-vedova.jpg',
        },
        {
          person: this.$i18n.t('content.employeesSays.6.person'),
          text: this.$i18n.t('content.employeesSays.6.text'),
          img: 'paula-da-silva-rego-nuno-ferreira-da-fonseca.jpg',
        },
        {
          person: this.$i18n.t('content.employeesSays.7.person'),
          text: this.$i18n.t('content.employeesSays.7.text'),
          img: 'leopold-ott.jpg',
        },
        {
          person: this.$i18n.t('content.employeesSays.8.person'),
          text: this.$i18n.t('content.employeesSays.8.text'),
          img: 'robert-fiedler.jpg',
        },
        {
          person: this.$i18n.t('content.employeesSays.9.person'),
          text: this.$i18n.t('content.employeesSays.9.text'),
          img: 'davide-torri.jpg',
        },
        {
          person: this.$i18n.t('content.employeesSays.10.person'),
          text: this.$i18n.t('content.employeesSays.10.text'),
          img: 'massimo-rodella.jpg',
        },
        {
          person: this.$i18n.t('content.employeesSays.11.person'),
          text: this.$i18n.t('content.employeesSays.11.text'),
          img: 'patti-clara.jpg',
        },
      ];
      return quotes;
    },
    faqs() {
      const faqs = [
        {
          label: this.$i18n.t('content.faqsEmployees.cooperations.label'),
          items: [
            {
              question: this.$i18n.t('content.faqsEmployees.cooperations.1q'),
              answer: 'content.faqsEmployees.cooperations.1a',
              link: true,
              type: 'link',
              routeName: 'page.employee.seco-pilot',
            },
            {
              question: this.$i18n.t('content.faqsEmployees.cooperations.2q'),
              answer: this.$i18n.t('content.faqsEmployees.cooperations.2a'),
            },
            {
              question: this.$i18n.t('content.faqsEmployees.cooperations.3q'),
              answer: this.$i18n.t('content.faqsEmployees.cooperations.3a'),
            },
            {
              question: this.$i18n.t('content.faqsEmployees.cooperations.4q'),
              answer: 'content.faqsEmployees.cooperations.4a',
              link: true,
              type: 'contact',
            },
            {
              question: this.$i18n.t('content.faqsEmployees.cooperations.5q'),
              answer: this.$i18n.t('content.faqsEmployees.cooperations.5a'),
            },
          ],
        },
        {
          label: this.$i18n.t('content.faqsEmployees.offSeason.label'),
          items: [
            {
              question: this.$i18n.t('content.faqsEmployees.offSeason.1q'),
              answer: 'content.faqsEmployees.offSeason.1a',
              link: true,
              type: 'link',
              routeName: 'page.employee.seco-pilot',
            },
            {
              question: this.$i18n.t('content.faqsEmployees.offSeason.2q'),
              answer: this.$i18n.t('content.faqsEmployees.offSeason.2a'),
            },
            {
              question: this.$i18n.t('content.faqsEmployees.offSeason.3q'),
              answer: this.$i18n.t('content.faqsEmployees.offSeason.3a'),
            },
            {
              question: this.$i18n.t('content.faqsEmployees.offSeason.4q'),
              answer: this.$i18n.t('content.faqsEmployees.offSeason.4a'),
            },
            {
              question: this.$i18n.t('content.faqsEmployees.offSeason.5q'),
              answer: this.$i18n.t('content.faqsEmployees.offSeason.5a'),
            },
            {
              question: this.$i18n.t('content.faqsEmployees.offSeason.6q'),
              answer: this.$i18n.t('content.faqsEmployees.offSeason.6a'),
            },
            {
              question: this.$i18n.t('content.faqsEmployees.offSeason.7q'),
              answer: this.$i18n.t('content.faqsEmployees.offSeason.7a'),
            },
          ],
        },
        {
          label: this.$i18n.t('content.faqsEmployees.notifications.label'),
          items: [
            {
              question: this.$i18n.t('content.faqsEmployees.notifications.1q'),
              answer: this.$i18n.t('content.faqsEmployees.notifications.1a'),
            },
          ],
        },
      ];
      return faqs;
    },
  },
  methods: {
    scrollToSection(section) {
      if (section !== '') {
        this.$vuetify.goTo(section);
      }
    },
    scrollToHash() {
      this.scrollToSection(this.$route.hash);
    },
    generateStartQuote() {
      this.startQuote = Math.floor(Math.random() * this.quotes.length) + 1;
    },
    openContactFormDialog() {
      if (this.authUser) {
        this.$eventBus.$emit('show-contact-form-dialog');
      } else {
        this.$eventBus.$emit('show-user-login-dialog');
      }
    },
    openNewsletterRegistrationDialog() {
      this.$eventBus.$emit('show-newsletter-registration-dialog');
    },
  },
  watch: {
    $route: 'scrollToHash',
  },
};
</script>

<style lang="scss" scoped>
  ::v-deep {
    .v-expansion-panel-header {
      height: auto;
      min-height: 48px;
      line-height: 1.4em;
    }
  }
</style>
